export const BUTTONS = [
    "UP",
    "DOWN",
    "LEFT",
    "RIGHT",
    "A",
    "B",
    "X",
    "Y",
    "L",
    "R",
    "START",
    "SELECT",
];
export const BUTTON_SET = new Set(BUTTONS);
export function isButton(value) {
    return typeof value === "string" && BUTTON_SET.has(value);
}
export function normalizeButtons(state) {
    const out = {};
    for (const b of BUTTONS) {
        const v = state[b];
        if (v === true || v === false)
            out[b] = v;
    }
    return out;
}
//# sourceMappingURL=buttons.js.map